import React from 'react';
import { Select } from 'carbon-react/lib/components/select';

/**
 * Carbon's Select `onChange` signature widened from the classic React
 * ChangeEvent in v159+: it now emits `CustomSelectChangeEvent | React.ChangeEvent<HTMLInputElement>`.
 * Components that expose a plain `React.ChangeEvent<T>` handler need a thin
 * adapter so the two sides can be wired together without `as any`.
 *
 * The utility always returns a function (never undefined) because Carbon v159
 * made `Select.onChange` a required prop.
 */
type CarbonSelectOnChange = NonNullable<React.ComponentProps<typeof Select>['onChange']>;

export function adaptSelectChange<T extends HTMLElement = HTMLInputElement>(
  handler: ((e: React.ChangeEvent<T>) => void) | undefined
): CarbonSelectOnChange {
  return handler ? e => handler(e as unknown as React.ChangeEvent<T>) : () => undefined;
}
